<template>
  <BaseQuery>
    <BaseQueryRight :span="24">
      <el-form :model="form" :inline="true" :size="formSize">
        <el-form-item label="渠道:">
          <el-input v-model="form.channel" clearable placeholder="请输入渠道名称查询" />
        </el-form-item>
        <el-form-item label="媒体:">
          <el-input v-model="form.media" clearable placeholder="请输入媒体名称查询" />
        </el-form-item>
        <el-form-item label="城市:">
          <el-input v-model="form.city" clearable placeholder="请输入城市名称查询" />
        </el-form-item>
        <el-form-item label="日期:">
          <el-date-picker v-model="date" type="daterange" range-separator="至" start-placeholder="开始日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>

        <!-- <el-form-item label="开始日期:">
          <el-date-picker
            v-model="form.startDate"
            type="date"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item label="结束日期:">
          <el-date-picker
            v-model="form.endDate"
            type="date"
            placeholder="选择日期"
          />
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </BaseQueryRight>
  </BaseQuery>
</template>

<script>
export default {
  name: "QueryForm",
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {},
      date: [],
      formSize: "small",
    };
  },
  watch: {
    value: {
      handler(val) {
        this.form = val;
      },
      deep: true,
      immediate: true,
    },
    form: {
      handler(val) {
        this.$emit("input", val);
      },
      deep: true,
    },
    date: {
      handler(val) {
        if (!val) {
          this.form.startDate = this.form.endDate = "";
          return;
        }
        this.form.startDate = val[0];
        this.form.endDate = val[1];
      },
      deep: true,
    },
  },
  methods: {
    search() {
      this.$parent.page.page = 1;
      this.$emit("search");
    },
  },
};
</script>
